import React from "react";
import { getConfigTenant, getCompNightTermsUrl, isCorpTenant } from "@capone/common";
import { getEarnMultiplier } from "../rewards/utilities";

export const BANNER_SUBTITLE = (isVentureXOrVesper: boolean) =>
  isCorpTenant(getConfigTenant())
    ? `Extend your business trip—book a stay of four or more nights and get your fourth night free at select ${
        isVentureXOrVesper ? "Premier and Lifestyle" : "Lifestyle"
      } Collection Hotels.`
    : `Receive a complimentary fourth night when you book an eligible stay of at least four nights at select ${
        isVentureXOrVesper ? "Premier and Lifestyle" : "Lifestyle"
      } Collection Hotels.`;

export const VIEW_TERMS_AND_DETAILS = (
  <a
    target="_blank"
    rel="noreferrer"
    href={getCompNightTermsUrl()}
  >
    View offer terms and details.
  </a>
);
export const VALID_THROUGH_MOBILE = "Offer valid through 12/31/2026.";

export const LOADING_POPUP_TITLE = "for premium stays";
export const LOADING_POPUP_SUBTITLE_PREMIER_COLLECTION = (currency?: string) => {
  const { multiplier, currency: currencyText } = getEarnMultiplier(currency);
  return (
    <ul>
      <li>Earn 10{multiplier} {currencyText} on Premier & Lifestyle Collection Hotel bookings.</li>
      <li>
        Enjoy a $50 experience credit on Lifestyle Collection bookings and a $100
        experience credit on Premier Collection bookings.
      </li>
    </ul>
  );
};
export const LOADING_POPUP_SUBTITLE_LIFESTYLE_COLLECTION = (currency?: string) => {
  const { multiplier, currency: currencyText } = getEarnMultiplier(currency);
  return (
    <ul>
      <li>Earn 5{multiplier} {currencyText} on Lifestyle Collection Hotel bookings.</li>
      <li>Enjoy a $50 experience credit on Lifestyle Collection bookings.</li>
    </ul>
  );
};
